module.exports = __webpack_public_path__ + "img/product_34.edc5dbf.jpg";